import Request from './Request'
import moment from 'moment'
import _ from 'underscore'
import constants from '../constants/constant'

const PlanService = {
	async getLocationClassBaseInfo(client_id, location_class_id) {
		return await Request.get(`/api/clients/${client_id}/plans/locationclasses/${location_class_id}`)
	},
	async saveLocationClassBasePlan(client_id, location_class_id, data) {
		return await Request.post(`/api/clients/${client_id}/plans/locationclasses/${location_class_id}/base-plan`, data)
	},
	async bulkSaveLocationClassBasePlan(client_id, location_class_id, data) {
		return await Request.post(`/api/clients/${client_id}/plans/locationclasses/${location_class_id}/base-plan/bulk`, data)
	},
	async bulkSaveClientBasePlan(client_id, data) {
		return await Request.post(`/api/clients/${client_id}/plans/base-plan/bulk`, data)
	},
	async getLocationClassBasePlanDetail(client_id, location_class_id, start_date=null) {
		let params = {}
		if( start_date ) {
			params['start_date'] = start_date
		}
		return await Request.get(`/api/clients/${client_id}/plans/locationclasses/${location_class_id}/base-plan-detail`, params)
	},
	async getLocationClassHistoryPlanDetail(client_id, location_class_id) {
		return await Request.get(`/api/clients/${client_id}/plans/locationclasses/${location_class_id}/history-plan-detail`)
	},
	async getLocationClassLivePlanDetail(client_id, location_class_id, response_type='') {
		return await Request.get(`/api/clients/${client_id}/plans/locationclasses/${location_class_id}/live-plan-detail?response_type=${response_type}`)
	},
	async getLocationClassFuturePlanDetail(client_id, location_class_id) {
		return await Request.get(`/api/clients/${client_id}/plans/locationclasses/${location_class_id}/future-plan-detail`)
	},
	async saveLocationClassFuturePlan(client_id, location_class_id, data) {
		return await Request.post(`/api/clients/${client_id}/plans/locationclasses/${location_class_id}/future-plan`, data)
	},
	async bulkSaveLocationClassFuturePlan(client_id, location_class_id, method, data) {
		return await Request.post(`/api/clients/${client_id}/plans/locationclasses/${location_class_id}/future-plan/bulk/${method}`, data)
	},
	async bulkSaveClientFuturePlan(client_id, method, data) {
		return await Request.post(`/api/clients/${client_id}/plans/future-plan/bulk/${method}`, data)
	},
	async getLivePlanDetail(client_id, plan_id, plan_version) {
		return await Request.get(`/api/clients/${client_id}/plans/${plan_id}/${plan_version}/plan-detail`)
	},
	async getLivePlanBaseInfo(client_id, plan_id, plan_version) {
		return await Request.get(`/api/clients/${client_id}/plans/${plan_id}/${plan_version}`)
	},
	async makePlanLive(client_id, plan_id, plan_version) {
		return await Request.post(`/api/clients/${client_id}/plans/${plan_id}/${plan_version}/live`)
	},
	async removePlan(client_id, plan_id, plan_version) {
		return await Request.post(`/api/clients/${client_id}/plans/${plan_id}/${plan_version}/remove`)
	},
	async savePlan(client_id, plan_id, data, plan_version=null, future=false) {
		let query_string = '1'
		if( plan_version ) {
			query_string += `&version=${plan_version}`
		}
		if( future ) {
			query_string += `&future=${future}`
		}
		return await Request.post(`/api/clients/${client_id}/plans/${plan_id}?${query_string}`, data)
	},
	async getCopyPlans() {
		return await Request.get(`/api/copy-plans`)
	},
	async getCopyPlanFiles() {
		return await Request.get(`/api/copy-plan/files`)
	},
	async getCopyPlanDetail(id) {
		return await Request.get(`/api/copy-plans/${id}`)
	},
	async getCopyPlanFileDetail(id) {
		return await Request.get(`/api/copy-plan/files/${id}`)
	},
	async getRecentEpochmonth(offset=2) {
		const d1 = new moment("1970-01-01");
		const d2 = new moment();
		const corrent_epochmonth = d2.diff(d1, 'months');
		let data = []
		_.range(offset*2+1).forEach(i => {
			const _d = new moment().add(i-offset, 'months')
			data.push({
				date: _d,
				epochmonth: _d.diff(d1, 'months'),
				current: _d.diff(d1, 'months') == corrent_epochmonth
			})
		})
		return data
	},
	async uploadCopyPlanFile(file) {
		let formData = new FormData()
		formData.append("data", file)
		return await Request.formPost(`/api/copy-plan/files`, formData)
	},
	async createCopyPlanLine(data) {
		return await Request.post(`/api/copy-plan/line`, data)
	},
	async copyPlanReprocess(id) {
		return await Request.post(`/api/copy-plan/line/${id}/reprocess`)
	},
	async copyPlanFileReprocess(id) {
		return await Request.post(`/api/copy-plan/files/${id}/reprocess`)
	},
	async downloadCopyPlanFile(id) {
		window.open(`${constants.BACKEND_DOMAIN}/api/copy-plan/files/${id}/download?_access_token=${localStorage.getItem('access_token')}`, '_blank')
	},
	isPlannable(locationClass) {
        return locationClass.servicetypeid=='1' || locationClass.servicetypeid=='2'
    },
    async copyToBasePlanFromLocationClass(params) {
    	return Request.post(`/api/base-plan/copy-to`, params);
    },
    async copyToLivePlan(params) {
    	return Request.post(`/api/live-plan/copy-to`, params);
    },
}

export default PlanService